import axios from "axios";
import {
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_FAIL,
  USER_CHANGE_PASSWORD_REQUEST,
  USER_CHANGE_PASSWORD_SUCCESS,
  USER_CHANGE_PASSWORD_FAIL,
  USER_DETAILS_RESET,
  USER_FORGOT_FAIL,
  USER_FORGOT_REQUEST,
  USER_FORGOT_SUCCESS,
  USER_RESET_FAIL,
  USER_RESET_REQUEST,
  USER_RESET_SUCCESS,
  CUSTOMER_DETAILS_REQUEST,
  CUSTOMER_DETAILS_SUCCESS,
  CUSTOMER_DETAILS_FAIL,
} from "./userTypes";

import { BACK_URI } from "../../config/keys";
import { setAlert, removeAlert } from "../Alert/alert.actions";
import { getNotifications } from "../notifications/notificationsActions";

export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LOGIN_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    localStorage.removeItem("merchant");

    const { data } = await axios.post(`${BACK_URI}/auth/dash/login`, { email, password }, config);

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    });

    localStorage.setItem("userInfo", JSON.stringify(data));

    if (data.role == "ROLE_MERCHANT") {
      dispatch(loadMerchant());
    }
    // if (data.role == "ROLE_ADMIN" || data.role == "ROLE_SUPER_ADMIN") {
    if (data.role == "ROLE_ADMIN") {
      dispatch(loadAdmin());
    }

    localStorage.removeItem("notifications");
  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const forgot =
  (email, dash = true) =>
  async (dispatch) => {
    try {
      // dispatching action to display loader
      dispatch({
        type: USER_FORGOT_REQUEST,
      });
      dispatch(setAlert("sending reset link", "loading"));
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(`${BACK_URI}/auth/forgot`, { email, dash }, config);

      dispatch({
        type: USER_FORGOT_SUCCESS,
        payload: data.message,
      });
      dispatch(setAlert("RESET LINK SENT", "success", 2000));
    } catch (error) {
      dispatch(setAlert(" ", "loading", 200));
      dispatch({
        type: USER_FORGOT_FAIL,
        payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
      });
    }
  };

export const reset = (token, password) => async (dispatch) => {
  try {
    // dispatching action to display loader
    dispatch(setAlert(" ", "loading"));

    dispatch({
      type: USER_RESET_REQUEST,
    });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.post(
      `${BACK_URI}/auth/reset/${token}`,
      {
        password,
      },
      config
    );
    dispatch({
      type: USER_RESET_SUCCESS,
      payload: data.message,
    });
    dispatch(setAlert("Password Changed successfully", "success", 2000));
  } catch (error) {
    dispatch(removeAlert());
    dispatch({
      type: USER_RESET_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const loadMerchant = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_DETAILS_REQUEST,
    });

    const {
      userState: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: userInfo.token,
      },
    };

    const { data } = await axios.get(`${BACK_URI}/merchant`, config);

    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: data,
    });
    dispatch(getNotifications(data._id));
    localStorage.removeItem("userdata");
    localStorage.setItem("userdata", JSON.stringify(data));
    window.location.reload();
  } catch (error) {
    dispatch({
      type: USER_DETAILS_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const loadAdmin = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_DETAILS_REQUEST,
    });

    const {
      userState: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: userInfo.token,
      },
    };

    const { data } = await axios.get(`${BACK_URI}/admin`, config);

    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: data,
    });
    dispatch(getNotifications(data._id));
    localStorage.removeItem("userdata");
    localStorage.setItem("userdata", JSON.stringify(data));
    window.location.reload();
  } catch (error) {
    dispatch({
      type: USER_DETAILS_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const changePassword = (oldPassword, newPassword) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_CHANGE_PASSWORD_REQUEST,
    });

    const {
      userState: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: userInfo.token,
      },
    };

    const { data } = await axios.post(
      `${BACK_URI}/auth/changepassword`,
      { oldPassword, newPassword },
      config
    );

    dispatch({
      type: USER_CHANGE_PASSWORD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: USER_CHANGE_PASSWORD_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("userdata");
  dispatch({ type: USER_LOGOUT });
};

export const loadCustomerByEmail = (email) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CUSTOMER_DETAILS_REQUEST,
    });

    const {
      userState: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: userInfo.token,
      },
    };

    const { data } = await axios.get(`${BACK_URI}/customer/detail/email?email=${email}`, config);

    dispatch({
      type: CUSTOMER_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CUSTOMER_DETAILS_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};
